/**
 * Load More Articles
 */
function loadMoreArticles() {
  const config = {
    dom: {
      loadMoreButton: 'js-load-more-articles',
      articlesContainer: 'filtered-blog__articles',
    },
  };

  const c = __.extend(config);

  const $loadMoreButton = document.querySelector(`.${c.dom.loadMoreButton}`);
  const $articlesContainer = document.querySelector(`.${c.dom.articlesContainer}`);

  let currentArticleIndex = 12;

  // Extract the blog handle from the current URL
  const blogHandle = window.location.pathname.split('/')[2];

  function init() {
    if (!$loadMoreButton) return;
    $loadMoreButton.addEventListener('click', fetchAndRenderNextArticles);
  }

  function fetchAndRenderNextArticles() {
    const ajaxURL = `/blogs/${blogHandle}/?view=blog-articles`;

    __.ajax({
      url: ajaxURL,
      type: 'GET',
      success(response) {
        let articlesData;

        if (typeof response === 'string') {
          try {
            articlesData = JSON.parse(response);
          } catch (err) {
            console.error('Error parsing response:', err);
            return;
          }
        } else if (typeof response === 'object') {
          articlesData = response;
        } else {
          console.error('Unexpected response format:', response);
          return;
        }

        const articlesToRender = articlesData.articles
          .slice(currentArticleIndex, currentArticleIndex + 12);

        articlesToRender.forEach((article) => {
          const articleElement = `
            <div class="filtered-blog__articles-item">
              <a href="${article.url}">
                <div class="ir ir--article-preview-image filtered-blog__articles-image-wrapper">
                  <img src="${article.image.src}" class="filtered-blog__articles-image lazyload" alt="${article.image.alt}">
                </div>
              </a>
              <h3 class="filtered-blog__articles-title">
                <a href="${article.url}">${article.title}</a>
              </h3>
              <div class="filtered-blog__articles-excerpt rte">
                ${article.summary_html}
              </div>
              <p class="filtered-blog__articles-link">
                <a href="${article.url}">Read The Article</a>
              </p>
            </div>
          `;

          $articlesContainer.insertAdjacentHTML('beforeend', articleElement);
        });

        currentArticleIndex += 12;

        if (currentArticleIndex >= articlesData.articles.length) {
          $loadMoreButton.style.display = 'none';
        }
      },
      error(err) {
        console.error('Error fetching articles:', err);
        __.addClass($loadMoreButton, 'hide');
      },
    });
  }

  return init();
}

export default loadMoreArticles;
